var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main-content"},[_c('choiceness'),_c('div',{staticClass:"height8 bgF5F5F5"}),_c('voiceCourseTopList'),_c('div',{staticClass:"height8 bgF5F5F5"}),_c('recent-changes')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }